import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import RoutePaths from 'src/app/core/constants/route-paths';
import { SubscriptionModel } from 'src/app/core/models/entities/subscription.model';
import { UserModel } from 'src/app/core/models/entities/user.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { SubscriptionService } from 'src/app/core/services/contenful/subscription.service';

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
    user?: UserModel;
    subscription?: SubscriptionModel;

    constructor(
        private router: Router,
        private authService: AuthService,
        private subscriptionService: SubscriptionService
    ) {}

    ngOnInit() {
        this.authService.getCurrentUser$().subscribe((user) => {
            this.user = user || undefined;
            // if (this.user && this.user.subscriptionId) {
            //     this.subscriptionService
            //         .getSubscriptionById(this.user.subscriptionId)
            //         .then(async (subscription) => {
            //             if (subscription) {
            //                 this.subscription = subscription;
            //                 console.log(
            //                     "User subscription loaded in sidebar:",
            //                     this.subscription
            //                 );
            //             }
            //         });
            // }
        });
    }

    goToSubscription(): void {
      this.router.navigate([RoutePaths.SUBSCRIPTION, this.user?.subscriptionId]);
    }

    logout(): void {
        this.authService.logout();
        this.router.navigate(["/login"]);
    }
}
